'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useContext } from 'react';
import ReactGA from 'react-ga4';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useTranslations } from 'next-intl';
import { usePathname } from 'next/navigation';
import { amplitudeInstance } from '../../config/amplitude';
import AuthContext from '../../context/AuthContext';
import buildRouteUrl from '../../helpers/buildRouteUrl';
import useIntl from '../../hooks/useIntl';
import useModal from '../../hooks/useModal';
import { Link } from '../../i18n/navigation';
import * as fbq from '../../lib/fpixel';
import BrandLogo from '../BrandLogo';
import Search from '../Search';
// import SubscriptionsPlansModal from '../SubscriptionPlansModal';

function Header() {
  const $ = _c(61);
  const pathname = usePathname();
  const intl = useIntl();
  const t = useTranslations();
  const auth = useContext(AuthContext);
  let pathnameWithoutLocale;
  if ($[0] !== intl.locale || $[1] !== pathname) {
    pathnameWithoutLocale = pathname.replace(`${intl.locale}`, "");
    if (pathnameWithoutLocale.includes("//")) {
      pathnameWithoutLocale = pathnameWithoutLocale.slice(1);
    }
    $[0] = intl.locale;
    $[1] = pathname;
    $[2] = pathnameWithoutLocale;
  } else {
    pathnameWithoutLocale = $[2];
  }
  let t0;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = buildRouteUrl("/");
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Link href={t0} className="mr-2 md:mr-8" prefetch={true}><BrandLogo className="h-[22px] w-[144px]" priority={true} /></Link>;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <a href="/br/noticias" className="no-underline text-[#999] hover:text-white">Notícias</a>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = buildRouteUrl("/");
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `no-underline ${pathnameWithoutLocale === "/" ? "text-white font-bold" : "text-[#666] hover:opacity-[0.5] regular"}`;
  let t5;
  if ($[7] !== t) {
    t5 = t("header.links.home");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <Link href={t3} className={t4} prefetch={false}>{t5}</Link>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== auth.isLoading || $[13] !== auth.isLoggedIn || $[14] !== pathnameWithoutLocale || $[15] !== t) {
    t7 = !auth.isLoading && auth.isLoggedIn && <Link href={buildRouteUrl("/my-progress")} className={`no-underline ${pathnameWithoutLocale === "/my-progress" ? "text-white font-bold" : "text-[#666] hover:opacity-[0.5] regular"}`} prefetch={true}>{t("header.links.my_progress")}</Link>;
    $[12] = auth.isLoading;
    $[13] = auth.isLoggedIn;
    $[14] = pathnameWithoutLocale;
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== auth.isLoading || $[18] !== auth.isLoggedIn || $[19] !== pathnameWithoutLocale || $[20] !== t) {
    t8 = !auth.isLoading && auth.isLoggedIn && <Link href={buildRouteUrl("/my-list")} className={`no-underline ${pathnameWithoutLocale === "/my-list" ? "text-white font-bold" : "text-[#666] hover:opacity-[0.5] regular"}`} prefetch={true}>{t("header.links.my_list")}</Link>;
    $[17] = auth.isLoading;
    $[18] = auth.isLoggedIn;
    $[19] = pathnameWithoutLocale;
    $[20] = t;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t6 || $[23] !== t7 || $[24] !== t8) {
    t9 = <div className="flex flex-row items-center mr-8">{t1}<div className="hidden md:flex flex-row gap-x-3">{t2}{t6}{t7}{t8}</div></div>;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="hidden md:flex flex-row flex-1 justify-end"><div className="md:w-[80%]"><Search /></div></div>;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== auth || $[28] !== pathname || $[29] !== t) {
    t11 = <div className="flex flex-row items-center ml-0 md:ml-6">{auth.isLoggedIn ? <DropdownMenu.Root><DropdownMenu.Trigger><span className="text-white hover:text-[#666] font-bold">{auth.userData?.name}</span></DropdownMenu.Trigger><DropdownMenu.Portal style={{
          zIndex: 100
        }} className="z-10"><DropdownMenu.Content align="end" sideOffset={5} className="w-48 rounded-lg p-2 shadow-md md:w-56 bg-black z-10"><DropdownMenu.Item className="flex items-center rounded-md px-2 h-10 text-sm outline-none focus:bg-gray-200 cursor-pointer"><Link href={buildRouteUrl("/users/me")} className="flex-grow text-white" prefetch={true}>{t("profile.title")}</Link></DropdownMenu.Item><DropdownMenu.Item className="flex items-center rounded-md px-2 h-10 text-sm outline-none focus:bg-gray-200 cursor-pointer"><Link href={buildRouteUrl("/settings")} className="flex-grow text-white" prefetch={true}>{t("profile.settings")}</Link></DropdownMenu.Item><DropdownMenu.Item className="flex items-center rounded-md px-2 h-10 text-sm outline-none focus:bg-gray-200 cursor-pointer"><span onClick={() => auth.destroySession()} className="flex-grow text-white">{t("profile.logout")}</span></DropdownMenu.Item></DropdownMenu.Content></DropdownMenu.Portal></DropdownMenu.Root> : <Link onClick={() => amplitudeInstance.logEvent("Header Go To Login Button", {
        page_path: pathname
      })} href={buildRouteUrl("/login")} className="md:ml-4 text-white hover:text-gray-200 font-semibold uppercase">Login</Link>}</div>;
    $[27] = auth;
    $[28] = pathname;
    $[29] = t;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11 || $[32] !== t9) {
    t12 = <div className="flex flex-row justify-between items-center px-4 md:px-10 py-4 w-full h-[64px] min-h-[64px]">{t9}{t10}{t11}</div>;
    $[31] = t11;
    $[32] = t9;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <a href="/br/noticias" className="no-underline text-[#999] hover:text-white">Notícias</a>;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = buildRouteUrl("/");
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  const t15 = `no-underline ${pathname === "/" ? "text-white font-bold" : "text-[#666] regular"}`;
  let t16;
  if ($[36] !== t) {
    t16 = t("header.links.home");
    $[36] = t;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t15 || $[39] !== t16) {
    t17 = <Link href={t14} className={t15} prefetch={false}>{t16}</Link>;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== auth.isLoading || $[42] !== auth.isLoggedIn || $[43] !== pathname || $[44] !== t) {
    t18 = !auth.isLoading && auth.isLoggedIn && <Link href={buildRouteUrl("/my-progress")} className={`no-underline ${pathname === "/my-progress" ? "text-white font-bold" : "text-[#666] regular"}`} prefetch={true}>{t("header.links.my_progress")}</Link>;
    $[41] = auth.isLoading;
    $[42] = auth.isLoggedIn;
    $[43] = pathname;
    $[44] = t;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== auth.isLoading || $[47] !== auth.isLoggedIn || $[48] !== pathname || $[49] !== t) {
    t19 = !auth.isLoading && auth.isLoggedIn && <Link href={buildRouteUrl("/my-list")} className={`no-underline ${pathname === "/my-list" ? "text-white font-bold" : "text-[#666] regular"}`} prefetch={true}>{t("header.links.my_list")}</Link>;
    $[46] = auth.isLoading;
    $[47] = auth.isLoggedIn;
    $[48] = pathname;
    $[49] = t;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== t17 || $[52] !== t18 || $[53] !== t19) {
    t20 = <div className="flex flex-col items-center mr-8"><div className="flex flex-row gap-x-3">{t13}{t17}{t18}{t19}</div></div>;
    $[51] = t17;
    $[52] = t18;
    $[53] = t19;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  let t21;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="md:ml-4"><Search /></div>;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  let t22;
  if ($[56] !== t20) {
    t22 = <div className="flex md:hidden flex-row justify-between items-center px-4 md:px-10 py-4 bg-black w-full h-[56px] min-h-[56px]">{t20}{t21}</div>;
    $[56] = t20;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  let t23;
  if ($[58] !== t12 || $[59] !== t22) {
    t23 = <><div className="flex flex-col w-screen min-w-full justify-between items-center z-10 fixed bg-black">{t12}{t22}</div></>;
    $[58] = t12;
    $[59] = t22;
    $[60] = t23;
  } else {
    t23 = $[60];
  }
  return t23;
}
export default Header;